import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6689a0e7")

_pushScopeId("data-v-6689a0e7")
const _hoisted_1 = { class: "p-d-flex p-flex-md-column" }
const _hoisted_2 = { class: "p-d-flex p-flex-md-column" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Header)
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.notification.length > 0 && _ctx.showNotification)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "success",
          closable: true,
          onClick: _ctx.hideNotification
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.notification), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ], 64))
})